<template>
	<div class="login-container">
		<el-form :model="formLogin" :rules="rules2" ref="formLogin" label-position="left" label-width="0px" class="demo-ruleForm login-page">
			<div class="text-center padding-tb-xl">
				<div class="text-xxl">{{ $cfg.name }}</div>
				<div class="text-lg text-bold text-blue padding">v{{ $cfg.version }}</div>
			</div>
			<div class="padding-tb">
				<el-divider content-position="center"><span class="text-blue">用户登录</span></el-divider>
			</div>
			<el-form-item prop="username">
				<el-input type="text" v-model="formLogin.username" auto-complete="off" placeholder="用户名" prefix-icon="el-icon-user"></el-input>
			</el-form-item>
			<el-form-item prop="pass">
				<el-input type="password" show-password v-model="formLogin.pass" auto-complete="off" placeholder="密码" prefix-icon="el-icon-key"></el-input>
			</el-form-item>
			<el-form-item style="width:100%;"><el-button type="primary" style="width:100%;" @click="login" :loading="loading">登录</el-button></el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			formLogin: {
				username: '',
				pass: ''
			},
			rules2: {
				username: [
					{
						required: true,
						message: '请输入登陆账号',
						trigger: 'blur'
					}
				],
				pass: [
					{
						required: true,
						message: '请输入登陆密码',
						trigger: 'blur'
					}
				]
			},
			checked: false
		};
	},
	created: function() {},
	methods: {
		login(event) {
			this.$refs.formLogin.validate(valid => {
				if (valid) {
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					let promise = new Promise((resolve, reject) => {
						this.$http.post('/server/login.php?a=checku', { username: this.formLogin.username, pass: this.$md5(this.formLogin.username + this.formLogin.pass) }).then(
							res => {
								console.log(res)
									if (res.result == 'ok') {
										resolve(res.data);
									} else {
										this.$alert(res.msg, { title: '操作错误', type: 'error' });
										reject(res.msg);
									}
							},
							r => {
								console.log(r);
								this.$alert('网络错误，指定的服务无法访问。', { title: '系统错误', type: 'error' });
								reject('网络错误，指定的服务无法访问');
							}
						);
					});
					promise
						.then(r => {
							this.$http
								.post('/server/login.php?a=login', {
									user_id: r.user_id,
									pass: this.$md5(r.user_id + this.$md5(r.user_id + this.$md5(this.formLogin.pass)))
								})
								.then(
									res => {
										loading.close();
											if (res.result == 'ok') {
												this.$message({
													message: '登陆成功',
													type: 'success',
													offset: 66,
													duration: 1000,
													onClose: () => {
														this.$store.commit('LOGIN', res.data.token);
													}
												});
											} else {
												this.$alert(res.msg, { title: '操作错误', type: 'error' });
											}
									},
									r => {
										loading.close();
										this.$alert('网络错误，指定的服务无法访问。', { title: '系统错误', type: 'error' });
									}
								);
						})
						.catch(r => {
							loading.close();
						});
				} else {
					console.log('error submit!');
					return false;
				}
			});
		}
	}
};
</script>

<style scoped>
.login-container {
	width: 100%;
}

.login-page {
	-webkit-border-radius: 5px;
	border-radius: 5px;
	margin: 180px auto;
	width: 350px;
	padding: 35px 35px 15px;
	background: #fff;
	border: 1px solid #eaeaea;
	box-shadow: 0 0 25px #cac6c6;
}

label.el-checkbox.rememberme {
	margin: 0px 0px 15px;
	text-align: left;
}
</style>
